<!--
 * @Author: chengleilei
 * @Date: 2026-02-05 15:05:54
 * @Description: 流动服务车tab
-->
<template>
    <Card bordered dis-hover>
        <Form ref="formRef" :label-width="140" label-colon>
            <FormItem label="是否支持流动救援">
                <el-switch v-model="formData.isEnableHelp" disabled> </el-switch>
            </FormItem>
            <template v-if="formData.isEnableHelp">
                <FormItem label="车牌号"> {{ formData.numberPlate || '-' }} </FormItem>
                <FormItem label="最大救援半径(km)"> {{ formData.helpRadius || '-' }} </FormItem>
                <FormItem label="服务内容"> {{ formData.serveHelpName || formData.helpServiceNames || '-' }} </FormItem>
                <FormItem label="车头照">
                    <div v-if="fileList.length > 0">
                        <span
                            v-viewer="{ movable: false }"
                            v-for="(item, index) in fileList"
                            :key="index"
                            class="v-viewer-container"
                        >
                            <img :src="item.url" class="v-viewer-img" />
                        </span>
                    </div>
                    <div v-else>-</div>
                </FormItem>
            </template>
        </Form>
    </Card>
</template>

<script>
export default {
    props: {
        storeInfo: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            formData: {},
            fileList: [],
        };
    },
    watch: {
        storeInfo: {
            handler(val) {
                this.formData = { ...val };
                this.fileList = val.carImageUrl ? [{ url: val.carImageUrl }] : [];
            },
            deep: true,
        },
    },
};
</script>
